import { useTranslation } from "react-i18next";


export default function LanguageSelect({ className = "" }) {
  const { i18n } = useTranslation(); // <- instância certa
  const cur = (i18n.resolvedLanguage || i18n.language || "pt").slice(0, 2) as
    | "pt" | "en" | "es";

  return (
    <select
      className={`lang-select ${className}`}
      aria-label="Selecionar idioma"
      value={cur}
      onChange={(e) => i18n.changeLanguage(e.target.value)}  // <- aqui
    >
      <option value="pt">Português</option>
      <option value="en">English</option>
      <option value="es">Español</option>
    </select>
  );
}
